import styled from "styled-components"
import { media } from "../../../styles"

export const LayoutMain = styled.main``
